import { ColumnViewModel } from '../../shared/column-types';

export const nvariants_diseaseID_SUMMARY: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'variantStrID',
    'variantDSI',
    'variantDPI',
    'mostSevereConsequences',
    'chromosome',
    'hgvsc',
    'hgvsp',
    'coord',
    'alleles',
    'alleleFreqExome',
    'alleleFreqGenome',
    'DBSNPclass',
    'numDiseasesAssociatedToVariant',
  ],
  defaultVisible: [
    'geneSymbol',
    'variantStrID',
    'variantDSI',
    'variantDPI',
    'mostSevereConsequences',
    'chromosome',
    'coord',
    'alleles',
    'alleleFreqExome',
    'DBSNPclass',
    'numDiseasesAssociatedToVariant',
  ],
};
